import { cn } from '@/lib/cn';

/**
 * Switch accesible (role="switch"): el interruptor visual del panel. Verde
 * brand encendido, gris apagado; siempre con foco visible por teclado.
 */
export function Toggle({
  checked,
  onChange,
  label,
  disabled,
  className,
}: {
  checked: boolean;
  onChange: (next: boolean) => void;
  /** Etiqueta para lectores de pantalla (el texto visible vive fuera). */
  label: string;
  disabled?: boolean;
  className?: string;
}) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={label}
      disabled={disabled}
      onClick={() => onChange(!checked)}
      className={cn(
        // 21-oct, macOS 27: pista 54 × 24, perilla blanca en píldora 32 × 20 a 2 del borde.
        // En el teléfono el halo de toque llega a 44 de alto.
        'relative inline-flex h-6 w-[54px] shrink-0 items-center rounded-full transition-colors duration-200',
        'after:absolute after:-inset-y-2.5 after:inset-x-0 lateral:after:hidden',
        'focus-visible:outline-none focus-visible:ring-[3.5px] focus-visible:ring-acento/50',
        checked ? 'bg-acento' : 'bg-[var(--mac-interruptor)]',
        disabled && 'cursor-not-allowed opacity-50',
        className,
      )}
    >
      <span
        className={cn(
          'inline-block h-5 w-8 transform rounded-full bg-white shadow-[0_1px_4px_rgb(0_0_0/0.12)] transition-transform duration-200 motion-reduce:transition-none',
          checked ? 'translate-x-5' : 'translate-x-0.5',
        )}
      />
    </button>
  );
}
